import { render, staticRenderFns } from "./Carrello.vue?vue&type=template&id=2d38dcb3&scoped=true&"
import script from "./Carrello.vue?vue&type=script&lang=js&"
export * from "./Carrello.vue?vue&type=script&lang=js&"
import style0 from "./Carrello.vue?vue&type=style&index=0&id=2d38dcb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38dcb3",
  null
  
)

export default component.exports